





















































































import { QuestionNoMath } from '@/resource/question/question.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import {
  deleteQuestions,
  publishQuestions,
  unpublishQuestions,
} from '@/utils/add-question/add-question-util';

enum ActionTitle {
  Delete = 'delete',
  Publish = 'publish',
  Unpublish = 'unpublish',
}

@Component({
  components: { VueGoodTable },
})
export default class AdminQuestionContainer extends Vue {
  @Prop({ required: true })
  adminQuestions!: QuestionNoMath[];

  @Prop({ required: true })
  isSubjective!: boolean;

  selectedIds: number[] = [];
  password = process.env.VUE_APP_ADMIN_PASSWORD;
  passwordInput = '';
  isLoading = false;

  actionTitle: ActionTitle | null = null;
  currentAction: Function | null = null;

  get buttonVariant() {
    return this.selectedIds.length ||
      (this.selectedIds.length && (!this.isLoading || !this.currentAction))
      ? 'main'
      : 'disable';
  }

  get actionPlaceholder() {
    return this.actionTitle ? `Password for ${this.actionTitle}` : 'Password';
  }

  data: any[] = [];
  total = 0;
  columns = [
    {
      label: 'id',
      field: 'id',
      type: 'number',
    },
    {
      label: 'status',
      field: 'status',
    },
    {
      label: 'created by',
      field: 'createdBy',
    },
    {
      label: 'created date',
      field: 'createdAt',
    },
    {
      label: 'chapter',
      field: 'chapter',
    },
    {
      label: 'form',
      field: 'form',
    },
    {
      label: 'keyword',
      field: `keywords`,
    },
    {
      label: 'public',
      field: 'public',
    },
    {
      label: 'personal',
      field: 'private',
    },
    {
      label: 'view',
      field: 'link',
    },
    {
      label: 'customSearch',
      field: 'customSearch',
      hidden: true,
    },
  ];

  getData() {
    if (!this.adminQuestions) return null;
    this.data = this.adminQuestions.map(question => {
      return {
        id: question.id,
        status: question.isDraft ? 'draft' : 'publish',
        createdBy: question.user ? question.user.firstName : 'No user',
        createdAt: this.$dayjs(question.createdAt).format('h:mma, DD/M/YYYY'),
        form: question.chapter.form - 6,
        chapter: question.chapter.prefix,
        public: question.isPublic ? 'public' : 'private',
        private: question.isPrivate ? 'personal' : 'all users',
        keywords:
          question.keywords.join(', ') !== ''
            ? question.keywords.join(', ')
            : 'N/A',
        customSearch: [
          `status=${question.isDraft ? 'draft' : 'publish'}`,
          `createdBy=${question.user ? question.user.firstName : 'No user'}`,
          `form=${question.chapter.form - 6}`,
          `chapter=${question.chapter.prefix}`,
          `public=${question.isPublic ? 'public' : 'private'}`,
          `private=${question.isPrivate ? 'personal' : 'all users'}`,
        ],
        link: `/question-editor?question-id=${question.id}&is-subjective=${this.isSubjective}&is-admin=true`,
      };
    });
  }

  created() {
    this.total = this.adminQuestions.length;
    this.getData();
  }

  selectionChanged(selectedArray: any) {
    this.selectedIds = selectedArray.selectedRows.map((item: any) => {
      return item.id;
    });
  }

  onSearch(params: any) {
    this.total = params.rowCount;
  }

  searchData(row: any, col: any, cellValue: string, searchTerm: string) {
    const isCustomSearch = searchTerm.search('=');
    const searchTerms = searchTerm.split(',');

    if (isCustomSearch !== -1 && col.field === 'customSearch') {
      let count = 0;

      for (const searchTerm of searchTerms) {
        const i = ((cellValue as unknown) as any[]).indexOf(searchTerm);

        if (i !== -1) {
          count += 1;
        }
      }

      if (count === searchTerms.length) {
        return true;
      } else {
        return false;
      }
    } else if (searchTerm == '') {
      return true;
    } else {
      return `${cellValue}`.search(searchTerm) !== -1;
    }
  }

  async deleteQuestions() {
    if (!this.selectedIds.length || this.isLoading || this.currentAction)
      return;
    this.currentAction = deleteQuestions;
    this.actionTitle = ActionTitle.Delete;
  }

  async publishQuestions() {
    if (!this.selectedIds.length || this.isLoading || this.currentAction)
      return;
    this.currentAction = publishQuestions;
    this.actionTitle = ActionTitle.Publish;
  }

  async unpublishQuestions() {
    if (!this.selectedIds.length || this.isLoading || this.currentAction)
      return;
    this.currentAction = unpublishQuestions;
    this.actionTitle = ActionTitle.Unpublish;
  }

  async submitAction() {
    this.isLoading = true;
    if (this.passwordInput !== this.password) {
      this.$toasted.global.mainToast({
        message: 'Password wrong',
      });

      this.currentAction = null;
      this.passwordInput = '';
      this.isLoading = false;

      return;
    }

    if (this.currentAction) {
      await this.currentAction({
        questionIds: this.selectedIds,
        isSubjective: this.isSubjective,
      });
    }

    this.$emit('fetchAdminQuestions');
    this.isLoading = false;
  }
}
